export const ENTITY_LABELS_API_URL = 'ui/entity_labels';

export const entityLabelsQueryKeys = {
  base: ['entity-labels'],
  byCategory: (category: string) => [...entityLabelsQueryKeys.base, category],
};
